var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"listel",staticClass:"messagelist"},_vm._l((_vm.messages),function(msg){return _c('message',{key:msg.id,attrs:{"message":msg}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }